(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"), require("Vue"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["_", "Vue", "axios"], factory);
	else if(typeof exports === 'object')
		exports["visualization-tongre-vulkan"] = factory(require("_"), require("Vue"), require("axios"));
	else
		root["visualization-tongre-vulkan"] = factory(root["_"], root["Vue"], root["axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__60bb__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 